var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "propertyDioBox",
      attrs: {
        title: "Share Property",
        visible: _vm.showMsgDio,
        "append-to-body": true,
        "close-on-click-modal": false,
        "show-close": true,
        "before-close": _vm.close,
        center: "",
        width: "770px"
      },
      on: {
        "update:visible": function($event) {
          _vm.showMsgDio = $event
        }
      }
    },
    [
      _c("div", [_vm._v("Property Link")]),
      _vm._v(" "),
      _c(
        "el-input",
        {
          staticStyle: { margin: "15px 0" },
          attrs: { placeholder: "", disabled: true },
          model: {
            value: _vm.url,
            callback: function($$v) {
              _vm.url = $$v
            },
            expression: "url"
          }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "clipboard",
                  rawName: "v-clipboard:copy",
                  value: _vm.url,
                  expression: "url",
                  arg: "copy"
                },
                {
                  name: "clipboard",
                  rawName: "v-clipboard:success",
                  value: _vm.onCopy,
                  expression: "onCopy",
                  arg: "success"
                },
                {
                  name: "clipboard",
                  rawName: "v-clipboard:error",
                  value: _vm.onError,
                  expression: "onError",
                  arg: "error"
                }
              ],
              staticClass: "newBtn-sharing",
              attrs: { slot: "suffix" },
              slot: "suffix"
            },
            [_vm._v("Copy")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", [_vm._v("Share Passphrase")]),
      _vm._v(" "),
      _c(
        "el-input",
        {
          staticStyle: { margin: "15px 0" },
          attrs: { placeholder: "", maxlength: "12" },
          model: {
            value: _vm.passwordnew,
            callback: function($$v) {
              _vm.passwordnew = $$v
            },
            expression: "passwordnew"
          }
        },
        [
          _vm.showSave
            ? _c(
                "span",
                {
                  staticClass: "newBtn-sharing",
                  attrs: { slot: "suffix" },
                  on: { click: _vm.savePassword },
                  slot: "suffix"
                },
                [_vm._v("Save")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-top": "30px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: {
                background: "#333",
                border: "none",
                width: "200px"
              },
              attrs: { type: "primary" },
              on: { click: _vm.closeOrOpen }
            },
            [_vm._v(_vm._s(_vm.titMsg))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22a4f2c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a4f2c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/sharing.vue
// module id = null
// module chunks = 